var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowReturnTableLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49875 3.87748H3.24835L5.12023 2.00559L3.98964 0.875L0.741844 4.12279C0.427198 4.43744 0.427198 4.94407 0.741844 5.25339L3.96297 8.47452L5.09357 7.34392L3.22169 5.47204H7.49875C8.82133 5.47204 9.89326 6.38398 9.89326 7.49858C9.89326 8.61317 8.816 9.52512 7.49875 9.52512H6.6988V11.125H7.49875C9.70127 11.125 11.4932 9.49845 11.4932 7.49858C11.4932 5.49871 9.70127 3.87214 7.49875 3.87214V3.87748Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowReturnTableLeft);
export default __webpack_public_path__ + "static/media/ic_arrow_return_table_left.b13bde9fb03be9f234ee8e603a31fdf1.svg";
export { ForwardRef as ReactComponent };